export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/minmax.worker.15a9aab8.worker.js");
}
